import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

import Cluster from '../Support/Cluster';
import Loader from '../UI/Loader';
import Processing from '../UI/Processing';

import Header from '../Blocks/Header';

import MatterForm from '../Blocks/MatterForm';
import OffersForm from '../Blocks/OffersForm';
import ManageForm from '../Blocks/ManageForm';

import PositionTable from '../Blocks/PositionTable';
import PositionGraph from '../Blocks/PositionGraph';

import Printable from '../Blocks/Printable';


class Matter extends Component {

	state = {
		active_tab: 'claim',
		tabs: {
			claim: 'Claim',
			offers: 'Offers',
			delete_matter: 'Manage'
		},
		active_position: -1,
		pane_open: 0
	}

	componentDidMount() {
		if(this.props.user !== null && this.props.token !== null) {
			this.props.rdxLoadMatter(this.props.token,this.props.match.params.id);
		}
	}

	setActiveTab = (tab) => {
		this.setState({active_tab: tab});
	}

	setActivePosition = (p) => {
		let new_position = parseInt(p,10);
		if(+new_position === +this.state.active_position)
			this.setState({active_position: -1});
		else
			this.setState({active_position: new_position});
	}

	saveMeasures = () => {
		if(this.props.user === null || this.props.token === null) return;
		if(this.state.active_tab === 'claim')
			this.props.rdxSaveMeasures(this.props.token,this.props.matter.id,this.props.measures,this.props.matter.has_counter);
		else if(this.state.active_tab === 'offers')
			this.props.rdxSaveOffers(this.props.token,this.props.matter.id,this.props.offers_primary,this.props.offers_counter);
	}

	togglePane = () => {
		let new_state = 1;
		if(this.state.pane_open === 1)
			new_state = 0;
		this.setState({pane_open: new_state});
	}

	render() {

		let content = <Loader />;

		let tabs = Object.keys(this.state.tabs)
			.map(slug => {
				let classes = 'matter__tab';
				if(this.state.active_tab === slug) classes += ' matter__tab--selected';
				return (
					<li key={slug} className={classes} onClick={this.setActiveTab.bind(null,slug)}>{this.state.tabs[slug]}</li>
				);
			});

		let update_btn_text = 'Update';
		if(this.state.active_tab === 'offers') update_btn_text = 'Save Offers';
		let update_btn = <button className='huge-btn' onClick={this.saveMeasures}>{update_btn_text}</button>;

		if(this.state.active_tab === 'delete_matter') update_btn = null;

		if(this.props.matter) {

			let cc_btn = 'huge-btn huge-btn--brown';
			if(this.props.matter.has_counter) cc_btn = 'huge-btn huge-btn--soft';
			if(this.props.matter.measure_saving || this.props.matter.offers_saving) update_btn = <Processing />

			let form_size = 'standard';
			if(window.outerWidth >= 1024)
				form_size = 'small';

			let tab_content = (
				<Cluster>
					<MatterForm size={form_size} />
					<div className='matter__pane__footer'>
						<button className={cc_btn} onClick={this.props.rdxToggleCounterClaim}>{this.props.matter.has_counter ? 'Remove' : 'Add'} Counter Claim</button>
					</div>
				</Cluster>
			);
			if(this.state.active_tab === 'offers') {
				tab_content = <OffersForm size={form_size} />;
			} else if(this.state.active_tab === 'delete_matter') {
				tab_content = <ManageForm size={form_size} />;
			}

			const postable_plaintiff = <PositionTable ident='plaintiff' name="Plaintiff's Position" results={this.props.results_plaintiff} colour="orange" selector={this.setActivePosition} activePosition={this.state.active_position} />;
			const postable_defendant = <PositionTable ident='defendant' name="Defendant's Position" results={this.props.results_defendant} colour="blue" selector={this.setActivePosition} activePosition={this.state.active_position} />;

			let position_tables = (
				<Cluster>
					{postable_plaintiff}
					{postable_defendant}
				</Cluster>
			);

			if(this.props.matter.angle === 'defendant') {
				position_tables = (
					<Cluster>
						{postable_defendant}
						{postable_plaintiff}
					</Cluster>
				);
			}

			let matter_pane_classes = 'matter__pane screen-only';
			let matter_pane_toolbar = 'matter__toolbar screen-only';
			if(this.state.pane_open === 1) {
				matter_pane_classes += ' matter__pane--open';
				matter_pane_toolbar += ' matter__toolbar--open';
			}

			content = (
				<div className='matter'>

					<div className='matter__header screen-only'>
						<div className='wrapper'>

							<div className='pull-left'>
								<h3 className='matter__header__code'>Matter ID: {this.props.matter.code}</h3>
							</div>

							<div className='pull-right matter__header__control'>
								{update_btn}
							</div>

						</div>
					</div>

					<div className='matter__body'>

						<div className='wrapper clearfix'>

							<div className={matter_pane_toolbar}>
								<div className='pull-left'>
									<button className='btn btn--grey' onClick={this.togglePane}><i className='fas fa-angle-left'></i> Close</button>
								</div>
								<div className='pull-right'>
									{update_btn}
								</div>
							</div>

							<div className={matter_pane_classes}>
								<ul className='matter__tabs'>
									{tabs}
								</ul>
								<div className='matter__pane__content'>
									{tab_content}
								</div>
							</div>

							<div className='matter__results'>

								<h2 className='matter__results__headline'>Mediation Settlement - Commercial</h2>

								<PositionGraph data={this.props.results_graphed} selector={this.setActivePosition} activePosition={this.state.active_position} offersPrime={this.props.offers_primary} offersCounter={this.props.offers_counter} />

								<div className='matter__results__tables clearfix'>
									<div className='matter__results__reference screen-only'>
										<ul className='clearfix'>
											<li className='left'><strong><i className='fas fa-gavel'></i>:</strong> Trial</li>
											<li className='right'><strong><i className='fas fa-comment'></i>:</strong> Mediation</li>
											<li className='left'><strong>CD:</strong> Court Decision</li>
											<li className='right'><strong>MS:</strong> Mediated Settlement</li>
											<li className='left'><strong>LC:</strong> Legal Costs</li>
											<li className='right'><strong>NS:</strong> Net Settlement</li>
										</ul>
									</div>
									{position_tables}
								</div>

								<Printable />

							</div>

						</div>

					</div>

				</div>
			);
		}

		return (
			<Cluster>
				<Header />
				<div className='matter__toggle screen-only' onClick={this.togglePane}><i className='fas fa-pencil-alt'></i> Edit</div>
				{content}
			</Cluster>
		);
	}

}

const mapStateToProps = state => {
	return {
		matter: state.matter,
		measures: state.measures,
		results_plaintiff: state.results_plaintiff,
		results_defendant: state.results_defendant,
		results_graphed: state.results_graphed,
		offers_primary: state.offers_primary,
		offers_counter: state.offers_counter,
		token: state.token,
		user: state.user
	};
}

const mapDispatchToProps = dispatch => {
	return {
		rdxLoadMatter: 			(token,id) => dispatch(actions.loadMatter(token,id)),
		rdxToggleCounterClaim: 	() => dispatch(actions.toggleCounterClaim()),
		rdxSaveMeasures: 		(token,id,measures,has_counter) => dispatch(actions.saveMeasures(token,id,measures,has_counter)),
		rdxSaveOffers: 			(token,id,primary,counter) => dispatch(actions.saveOffers(token,id,primary,counter))
	};
}



export default connect(mapStateToProps, mapDispatchToProps)(Matter);


// WEBPACK FOOTER //
// ./src/Pages/Matter.js